import { createTheme } from "@mui/material/styles";
import uiConfig from "../config/uiConfig";

const palettesByMode = {
  light: {
    mode: "light",
    background: {
      default: "#f8fafc",
      paper: "#ffffff",
    },
    primary: {
      main: uiConfig.buttonColor,
    },
    text: {
      primary: "#0f172a",
      secondary: "#64748b",
    },
    divider: "#e5e7eb",
  },
  dark: {
    mode: "dark",
    background: {
      default: "#0f172a",
      paper: "#1e293b",
    },
    primary: {
      main: uiConfig.buttonColor,
    },
    text: {
      primary: "#f1f5f9",
      secondary: "#94a3b8",
    },
    divider: "#334155",
  },
};

export const getTheme = (mode = "light") => {
  const palette = palettesByMode[mode] || palettesByMode.light;
  const isDark = mode === "dark";

  return createTheme({
    palette,

    typography: {
      fontFamily: "Inter, Roboto, Arial",
    },

    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            background: palette.background.paper,
            border: `1px solid ${isDark ? "#334155" : "#e5e7eb"}`,
            borderRadius: "12px",
            boxShadow: isDark ? "0 2px 8px rgba(0,0,0,0.4)" : "0 2px 8px rgba(0,0,0,0.05)",
          },
        },
      },

      MuiPaper: {
        styleOverrides: {
          root: {
            background: palette.background.paper,
          },
        },
      },

      MuiTableCell: {
        styleOverrides: {
          root: {
            color: palette.text.primary,
            borderBottom: `1px solid ${isDark ? "#334155" : "#e5e7eb"}`,
          },
        },
      },
    },
  });
};

export default getTheme("light");
